import React, { useState } from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react/lib/Stack";

const DeleteReason = ({ onSend, closeDialog }) => {
  const [reason, setReason] = useState("");

  const handleSend = () => {
    if (reason.trim() === "") {
      alert("Please provide a reason before sending.");
      return;
    }
    onSend(reason);
    if (closeDialog) {
      closeDialog();
    }
  };

  return (
    <Stack
      tokens={{ childrenGap: 12 }}
      styles={{ root: { maxWidth: 400, marginTop: 20 } }}
    >
      <TextField
        label="Reason for deletion"
        multiline
        rows={4}
        value={reason}
        onChange={(_, newValue) => setReason(newValue)}
        placeholder="Enter reason here..."
        required
      />
      <PrimaryButton text="Send to Approver" onClick={handleSend} />
    </Stack>
  );
};

export default DeleteReason;



// WEBPACK FOOTER //
// ./src/components/CustomComponents/DeleteReason.js